import { GET_NOTIFICATIONS } from "../constants";
import { getNotifications as get } from "../api";

export const getNotifications = (params) => ({
  type: GET_NOTIFICATIONS,
  payload: get(params),
});
